import React from 'react';
import { useNavigate } from "react-router";


function NotFound(){
    let navigate = useNavigate(); // navigate react function
    
 return(
  <div>
    <h1>404 - Not Found!</h1>
    <p onClick={()=>{navigate("/")}} to="/">Go Home</p>
  </div>
)}

export default NotFound;